import { FundVisibility, Fund } from '../model/Fund';
import { UnitCategoryCode } from '../model/UnitCategory';

export const isVisibleForUnitCategory = (fundVisibility: FundVisibility, unitCategory: UnitCategoryCode): boolean => {
  switch (unitCategory) {
    case UnitCategoryCode.A: return fundVisibility?.isVisibleInAUnit;
    case UnitCategoryCode.K: return fundVisibility?.isVisibleInKUnit;
    case UnitCategoryCode.E: return fundVisibility?.isVisibleInEUnit;
    case UnitCategoryCode.F: return fundVisibility?.isVisibleInFUnit;
    case UnitCategoryCode.S: return fundVisibility?.isVisibleInSUnit;
    case UnitCategoryCode.T: return fundVisibility?.isVisibleInTUnit;
    case UnitCategoryCode.W: return fundVisibility?.isVisibleInWUnit;
    default: return false;
  }
};

export const isFundVisibleForUnitCategory = (fund: Fund, unitCategory: UnitCategoryCode): boolean => {
  return !!fund && isVisibleForUnitCategory(fund.fundVisibility, unitCategory)
      && fund.afsCodeForUnitCode?.[unitCategory] != null;
};